import { InvoiceModal } from "./InvoiceModal";

export default InvoiceModal;
